<template>
  <v-layout row wrap justify-center>
    <pg-detail
      :title="title"
      :primary_key="primary_key"
      :primary_field="primary_field"
      :deleteProcess="deleteDialog"
      checkCreator
      @found="selected = [$event]"
      @add="openInputDialog('ADD')"
      @update="openInputDialog('UPDATE')"
      @delete="deleteDialog = true"
    >
      <template slot="detail-content" slot-scope="props">
        <v-layout row wrap>
          <v-flex xs12 sm6>
            <v-list two-line subheader>
              <v-list-tile>
                <v-list-tile-action>
                  <v-icon color="secondary">chrome_reader_mode</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>Judul Materi</v-list-tile-title>
                  <v-list-tile-sub-title
                    >{{ props.detail.materi }}
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-divider inset></v-divider>
            </v-list>
            <v-list three-line subheader>
              <v-list-tile>
                <v-list-tile-action>
                  <v-icon color="secondary">toc</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>Tujuan </v-list-tile-title>
                  <v-list-tile-sub-title>{{
                    props.detail.tujuan | noEmpty
                  }}</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-divider inset></v-divider>
            </v-list>
            <v-list two-line subheader>
              <v-list-tile>
                <v-list-tile-action>
                  <v-icon color="secondary">turned_in_not</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>Kompetensi</v-list-tile-title>
                  <v-list-tile-sub-title
                    >{{ props.detail.kompetensi | noEmpty }}
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-divider inset></v-divider>
              <v-list-tile>
                <v-list-tile-action>
                  <v-icon color="secondary">local_offer</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>Business Unit</v-list-tile-title>
                  <v-list-tile-sub-title
                    >{{ props.detail.laman }}
                    <small>{{ props.detail.laman_desc }}</small>
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-divider inset></v-divider>
              <v-list-tile>
                <v-list-tile-action>
                  <v-icon color="secondary">assignment_turned_in</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>Total Training</v-list-tile-title>
                  <v-list-tile-sub-title
                    >{{ props.detail.total_training }}
                    <small>Training</small>
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-divider inset></v-divider>
              <v-list-tile
                v-ripple
                :to="{ name: 'User', query: { id: props.detail.id_user } }"
              >
                <v-list-tile-action>
                  <v-icon color="secondary">person</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>Dibuat oleh</v-list-tile-title>
                  <v-list-tile-sub-title>{{
                    props.detail.username
                  }}</v-list-tile-sub-title>
                </v-list-tile-content>
                <v-list-tile-avatar class="viewer" v-viewer>
                  <img
                    v-lazy="c.PHOTO_PROFIL_URL + props.detail.photo_profil"
                    :alt="props.detail.username"
                  />
                </v-list-tile-avatar>
              </v-list-tile>
              <v-divider inset></v-divider>
            </v-list>
          </v-flex>
          <v-flex xs12 sm6>
            <v-expansion-panel class="elevation-1" focusable>
              <v-expansion-panel-content :value="true">
                <div slot="header">TRAINING TERKAIT</div>
                <v-subheader v-if="!props.detail.training.length" class="mb-3">
                  {{ title }} ini tidak memiliki keterkaitan data dengan
                  TRAINING.
                </v-subheader>
                <vue-perfect-scrollbar v-else style="max-height: 400px">
                  <v-list two-line>
                    <v-list-tile
                      v-for="(item, i) in props.detail.training"
                      :key="i"
                      style="border-bottom: 1px solid #eee"
                      v-ripple
                      :to="{
                        name: 'TrainingList',
                        query: { id: item.id_training }
                      }"
                    >
                      <v-list-tile-content>
                        <v-list-tile-title
                          >Diposting <b>{{ item.username }}</b
                          >,
                          <i>{{ item.waktu_mulai | moment("from", "now") }}</i>
                        </v-list-tile-title>
                        <v-list-tile-sub-title>{{
                          item.keterangan | noEmpty
                        }}</v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </v-list>
                </vue-perfect-scrollbar>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-flex>
        </v-layout>
      </template>
    </pg-detail>
    <template v-if="!$route.query.id">
      <v-flex xs12>
        <v-card>
          <v-card-title class="py-2">
            <v-btn color="green" dark icon @click.stop="openInputDialog('ADD')">
              <v-icon>add</v-icon>
            </v-btn>
            <v-btn
              color="blue"
              :disabled="selected.length != 1"
              dark
              icon
              @click.stop="openInputDialog('UPDATE')"
            >
              <v-icon>edit</v-icon>
            </v-btn>
            <v-btn
              color="red"
              :disabled="selected.length == 0"
              dark
              icon
              @click.stop="deleteDialog = true"
            >
              <v-icon>delete</v-icon>
            </v-btn>
            <json-excel
              v-if="profil.role == 'ADMIN'"
              :data="selected"
              :export-fields="jsonFields"
              :name="`${$route.name}.xls`"
            >
              <v-btn color="indigo" :disabled="selected.length == 0" dark icon>
                <v-icon>file_download</v-icon>
              </v-btn>
            </json-excel>
            <v-btn
              :color="!filterOn ? 'grey' : 'orange'"
              :disabled="!sourceData.length && !filterOn"
              dark
              icon
              @click.stop="filterDialog = true"
            >
              <v-icon>filter_list</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Pencarian"
              clearable
              single-line
              hide-details
            >
            </v-text-field>
          </v-card-title>

          <v-data-table
            v-if="!$vuetify.breakpoint.xs"
            v-model="selected"
            :headers="headers"
            :items="sourceData"
            :search="search"
            :pagination.sync="pagination"
            :loading="!materi_loaded"
            select-all
            item-key="id_materi"
            :rows-per-page-items="pages"
            rows-per-page-text="Data/hlm"
            class="elevation-1"
          >
            <template slot="headers" slot-scope="props">
              <tr>
                <th>
                  <v-checkbox
                    :input-value="props.all"
                    :indeterminate="props.indeterminate"
                    primary
                    hide-details
                    @click.native="toggleAll"
                  >
                  </v-checkbox>
                </th>
                <th
                  v-for="header in props.headers"
                  :key="header.text"
                  :class="[
                    'column sortable ',
                    pagination.descending ? 'desc' : 'asc',
                    header.value === pagination.sortBy ? 'active' : '',
                    header.align ? `text-xs-${header.align}` : 'text-xs-left'
                  ]"
                  @click="changeSort(header.value)"
                >
                  <v-icon small>arrow_upward</v-icon>
                  {{ header.text }}
                </th>
              </tr>
            </template>
            <v-progress-linear
              slot="progress"
              color="primary"
              :height="3"
              indeterminate
            >
            </v-progress-linear>
            <template slot="items" slot-scope="props">
              <tr
                :active="props.selected"
                class="nowrap"
                @click="toggleExpand(props)"
              >
                <td style="width: 80px">
                  <v-checkbox
                    v-if="
                      props.item.id_user == profil.id_user ||
                      profil.role == 'ADMIN'
                    "
                    :input-value="props.selected"
                    @click.stop="props.selected = !props.selected"
                    primary
                    hide-details
                  >
                  </v-checkbox>
                </td>
                <td>
                  <v-chip
                    small
                    label
                    @click.stop="
                      $router.push({
                        name: $route.name,
                        query: { id: props.item.id_materi }
                      })
                    "
                  >
                    {{ props.item.materi }}
                  </v-chip>
                </td>
                <td>{{ props.item.tujuan | noEmpty }}</td>
                <td>{{ props.item.kompetensi | noEmpty }}</td>
                <td class="text-xs-center">{{ props.item.total_training }}</td>
                <td>{{ props.item.username }}</td>
              </tr>
            </template>
            <template
              slot="expand"
              slot-scope="props"
              v-if="$vuetify.breakpoint.xs"
            >
              <v-card
                flat
                :color="$vuetify.dark ? 'grey darken-1' : 'grey lighten-5'"
              >
                <table class="expanded">
                  <tr v-for="(header, i) in headers" :key="`rows-${i}`">
                    <td>{{ header.text }}</td>
                    <td>{{ props.item[header.value] | noEmpty }}</td>
                  </tr>
                </table>
              </v-card>
            </template>
            <template slot="no-data">
              <v-alert
                :value="true"
                :color="materi_loaded ? 'warning' : 'info'"
                :icon="materi_loaded ? 'warning' : 'info'"
                class="pa-1"
              >
                <span v-if="!materi_loaded">Mengambil data...</span>
                <span v-else>Tidak ada data.</span>
              </v-alert>
            </template>
            <v-alert
              slot="no-results"
              :value="true"
              color="warning"
              icon="warning"
              class="pa-1"
            >
              Kata kunci "{{ search }}" tidak ditemukan.
            </v-alert>
          </v-data-table>

          <v-data-iterator
            v-else
            v-model="selected"
            :items="sourceData"
            :pagination.sync="pagination"
            :loading="!materi_loaded"
            :search="search"
            select-all
            item-key="id_materi"
            :rows-per-page-items="pages"
            rows-per-page-text="Data/hlm"
            row
            wrap
          >
            <v-flex slot="item" slot-scope="props" xs12>
              <v-card>
                <v-list-tile>
                  <v-list-tile-action>
                    <v-checkbox
                      :input-value="props.selected"
                      @click.stop="props.selected = !props.selected"
                      class="ma-0 pa-0"
                      hide-details
                      primary
                    >
                    </v-checkbox>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>{{
                      props.item.materi
                    }}</v-list-tile-title>
                  </v-list-tile-content>
                  <v-list-tile-action>
                    <v-btn
                      :to="{
                        name: $route.name,
                        query: { id: props.item.id_materi }
                      }"
                      fab
                      flat
                      small
                      color="primary"
                    >
                      <v-icon>keyboard_arrow_right</v-icon>
                    </v-btn>
                  </v-list-tile-action>
                </v-list-tile>
                <v-divider></v-divider>
                <v-slide-y-transition>
                  <!-- <div v-show="props.selected"> -->
                  <v-list
                    dense
                    :class="props.selected ? 'secondary white--text' : ''"
                  >
                    <v-list-tile v-for="(header, i) in simpleHeaders" :key="i">
                      <v-list-tile-content>
                        <v-list-tile-title>{{ header.text }}</v-list-tile-title>
                        <v-list-tile-sub-title>{{
                          props.item[header.value] | noEmpty
                        }}</v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </v-list>
                  <!-- </div> -->
                </v-slide-y-transition>
              </v-card>
            </v-flex>
            <template slot="no-data">
              <v-alert
                :value="true"
                color="warning"
                icon="warning"
                class="pa-1"
              >
                <span v-if="status.loading">Loading...</span>
                <span v-else>Tidak ada data.</span>
              </v-alert>
            </template>
            <v-alert
              slot="no-results"
              :value="true"
              color="warning"
              icon="warning"
              class="pa-1"
            >
              Kata kunci "{{ search }}" tidak ditemukan.
            </v-alert>
          </v-data-iterator>
        </v-card>
      </v-flex>

      <pg-form-filter
        :dialog="filterDialog"
        :filterOn="filterOn"
        :filter="filter"
        :source="sourceData"
        :sourceOriginal="sourceOriginal"
        :title="title"
        @close="filterDialog = false"
        @toggle="
          filterOn = !filterOn;
          filterDialog = false;
        "
        @filtered="filterSource = $event"
      >
        <template slot="filter-content" slot-scope="props">
          <v-autocomplete
            append-icon="chrome_reader_mode"
            attach
            hide-details
            item-text="materi"
            item-value="id_materi"
            multiple
            :items="materiByLaman"
            v-model="props.filter.id_materi"
            label="Judul Materi"
          >
          </v-autocomplete>
          <v-textarea
            auto-grow
            :rows="1"
            counter
            append-icon="toc"
            hide-details
            type="text"
            v-model="props.filter.tujuan"
            label="Tujuan"
          >
          </v-textarea>
          <v-autocomplete
            append-icon="turned_in_not"
            attach
            hide-details
            multiple
            :items="props.filter.field.kompetensi"
            v-model="props.filter.kompetensi"
            label="Kompetensi"
          >
          </v-autocomplete>
          <v-autocomplete
            append-icon="person_outline"
            attach
            hide-details
            item-text="username"
            item-value="id_user"
            :items="user"
            multiple
            v-model="props.filter.id_user"
            label="User"
          >
            <template slot="item" slot-scope="data">
              <v-list-tile-avatar>
                <img
                  v-lazy="c.PHOTO_PROFIL_URL + data.item.photo_profil"
                  :alt="data.item.username"
                />
              </v-list-tile-avatar>
              <v-list-tile-content
                :class="{ 'red--text': !parseInt(data.item.active_user) }"
              >
                <v-list-tile-title>{{ data.item.username }}</v-list-tile-title>
                <v-list-tile-sub-title>{{
                  data.item.role
                }}</v-list-tile-sub-title>
              </v-list-tile-content>
            </template>
          </v-autocomplete>
          <v-range-slider
            v-model="props.filter.total_training"
            label="Total Training"
            append-icon="assignment_turned_in"
            hide-details
            style="margin-top: 40px"
            always-dirty
            :min="props.filter.field.total_training[0]"
            :max="props.filter.field.total_training[1]"
            thumb-label="always"
          >
          </v-range-slider>
        </template>
      </pg-form-filter>
    </template>

    <pg-form-delete
      :dialog="deleteDialog"
      :selected="selected"
      :title="title"
      :primary_key="primary_key"
      @cancel="deleteDialog = false"
      @deleted="onDeleted"
      action="materi/DELETE_MATERI"
    >
      <template slot="item-detail" slot-scope="props">
        {{ props.item.materi }} - {{ props.item.laman }}
      </template>
    </pg-form-delete>

    <materi-input
      :dialog="inputDialog"
      :data="selected[0]"
      :title="title"
      :action="inputAction"
      :primary_key="primary_key"
      :primary_field="primary_field"
      @cancel="inputDialog = false"
      @submitted="onSubmitted"
    >
    </materi-input>
  </v-layout>
</template>

<script>
import _ from "lodash";
import c from "@/constants";
import JsonExcel from "vue-json-excel";
import PgDetail from "@/components/private/PgDetail";
import PgFormDelete from "@/components/private/PgFormDelete";
import PgFormFilter from "@/components/private/PgFormFilter";
import MateriInput from "@/components/pages/input/MateriInput";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { mapState, mapGetters } from "vuex";

const defaultFilter = {
  id_materi: [],
  kompetensi: [],
  id_user: [],
  tujuan: "",
  total_training: [0, 100],
  field: {
    total_training: [0, 100]
  },
  format: {
    id_materi: c.FORMAT.options,
    kompetensi: c.FORMAT.text_options,
    id_user: c.FORMAT.options,
    tujuan: c.FORMAT.text,
    total_training: c.FORMAT.number
  }
};

export default {
  name: "materi",
  components: {
    JsonExcel,
    VuePerfectScrollbar,
    PgDetail,
    PgFormDelete,
    PgFormFilter,
    MateriInput
  },
  data() {
    return {
      // datatable
      headers: [
        { text: "MATERI", value: "materi" },
        { text: "TUJUAN", value: "tujuan" },
        { text: "KOMPETENSI", value: "kompetensi" },
        { text: "TOTAL TRAINING", value: "total_training" },
        { text: "USER", value: "username" }
      ],
      pagination: {
        sortBy: "materi"
      },
      pages: [7, 10, 25, { text: "Semua", value: -1 }],
      selected: [],
      search: "",
      // dialog
      title: "MATERI",
      primary_field: "materi",
      primary_key: "id_materi",
      // delete
      deleteDialog: false,
      // filter
      filterDialog: false,
      filterSource: [],
      filterOn: false,
      filterHelperSourceUpdated: false,
      filter: _.cloneDeep(defaultFilter),
      // input
      inputDialog: false,
      inputAction: "ADD",
      // other
      c: c
    };
  },
  computed: {
    ...mapState(["status", "id_laman$"]),
    ...mapState("auth", ["profil"]),
    ...mapState("user", ["user"]),
    ...mapState("materi", ["materi_loaded"]),
    ...mapGetters("materi", ["materiByLaman"]),
    simpleHeaders() {
      return this.headers.filter(h => !["materi"].includes(h.value));
    },
    jsonFields() {
      return this.headers.reduce(
        (obj, item) => ((obj[item.text] = item.value), obj),
        {}
      );
    },
    sourceOriginal() {
      /* eslint-disable */
      this.filterHelperSourceUpdated = true;
      return _.cloneDeep(this.$store.getters["materi/materiByLamanPeriode"]);
    },
    sourceData() {
      let source = _.cloneDeep(this.sourceOriginal);
      if (
        (this.filterOn && !_.isEqual(source, this.filterSource)) ||
        (this.filterHelperSourceUpdated && this.filterSource.length)
      ) {
        source = this.filterSource;
        /* eslint-disable */
        this.filterHelperSourceUpdated = false;
      }
      return source;
    }
  },
  methods: {
    toggleAll() {
      let my_data = this.sourceData.filter(d => {
        if (this.profil.role == "ADMIN") return true;
        return d.id_user == this.profil.id_user;
      });
      if (this.selected.length == my_data.length) {
        this.selected = [];
      } else {
        this.selected = _.cloneDeep(my_data);
      }
    },
    toggleExpand(props) {
      if (this.$vuetify.breakpoint.smAndDown) {
        if (!props.selected) props.expanded = !props.expanded;
        else props.expanded = false;
      } else props.expanded = false;
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    openInputDialog(action) {
      this.inputAction = action;
      this.inputDialog = true;
    },
    onSubmitted(new_id) {
      this.inputDialog = false;
      if (!this.$route.query.id) {
        if (this.inputAction == "UPDATE") {
          setTimeout(() => {
            this.selected = [];
          }, 1000);
        }
      } else {
        if (this.inputAction == "ADD") {
          this.$router.push({
            name: this.$route.name,
            query: { id: new_id }
          });
        }
      }
    },
    onDeleted(selected) {
      this.selected = selected;
      // if all success, then close dialog
      if (!this.selected.length) this.deleteDialog = false;
    }
  },
  watch: {
    id_laman$() {
      this.selected = [];
      this.pagination.page = 1;
    }
  },
  mounted() {}
};
</script>
